import { Box, Button, Card, NavList } from '@deckee/deck-hand';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { captureEvent } from '../../../../services/event-capture';
import { selectUnitsConfig } from '../../../../services/store/modules/app-controls';
import { formatLatLon } from '../../../helpers/coordinate-helpers';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import IconWithTextLockup from '../../../lockups/IconWithTextLockup/IconWithTextLockup';
import { calendar, ReactSvg } from '../../../shared/vector-images';
import CustomDescription from '../../../shared/_deprecated/components/CustomDescription/CustomDescription';

const MarkerSummary = (props) => {
  const {
    latLon,
    title,
    description,
    customDescription,
    banner,
    buttonLabel,
    buttonAction,
    buttonHref,
    sharePath,
    shareText,
    markerType,
    image,
    eventDetails,
    id,
  } = props;

  const unitsConfig = useSelector(selectUnitsConfig);
  const history = useHistory();
  const theme = useTheme();

  const coordinateSystem = unitsConfig?.coordinate;
  const formattedLatLon = latLon
    ? formatLatLon(coordinateSystem, latLon.lat, latLon.lon)
    : null;

  return (
    <>
      {image && (
        <Card borderWidth="0">
          <Card.Heading
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <BasicDrawerLayout.HeaderImage alt={title} src={image} />
          </Card.Heading>
        </Card>
      )}

      {eventDetails && (
        <Card borderWidth="0">
          <Card.Body>
            <NavList edge grouped>
              <NavList.Item>
                <IconWithTextLockup
                  emphasis="heading"
                  image={
                    <ReactSvg
                      toDisplay={calendar()}
                      options={{
                        fillColor: theme.colors.primary,
                      }}
                      width={24}
                      height={24}
                    />
                  }
                  heading={eventDetails.organizer}
                  description="Event supporter"
                />
              </NavList.Item>
            </NavList>
          </Card.Body>
        </Card>
      )}

      {!eventDetails && (
        <Box mb="2">
          {description && !customDescription && <Box>{description}</Box>}
          {!description && customDescription && (
            <CustomDescription description={customDescription} />
          )}
        </Box>
      )}
      <Box color="darkergrey" mt="2" mb="3">
        {!eventDetails && <Box>{formattedLatLon}</Box>}
        {/* Marker banner to indicate source of information */}
        {banner && banner.source && (
          <Box mt="2">
            Source: {banner.source}{' '}
            {banner?.source?.toLowerCase() ===
            'florida fish and wildlife conservation commission'
              ? ' - Zones change from time to time and some zones may not be shown. Always visually verify zone information using on-water markers.'
              : null}
          </Box>
        )}
      </Box>
      {sharePath && sharePath !== '' && (
        <Button.Group wide>
          {(buttonHref || buttonAction) && (
            <Button href={buttonHref} onClick={buttonAction}>
              {buttonLabel}
            </Button>
          )}
          <Button
            outlined
            onClick={() => {
              captureEvent({
                type: 'marker summary: share',
                payload: {
                  sharePath,
                  shareText,
                  title,
                  description,
                  type: markerType,
                  id,
                },
              });
              history.push('/maps/share', {
                sharePath,
                shareText,
                title,
                description,
                type: markerType,
                id,
              });
            }}
          >
            Share
          </Button>
        </Button.Group>
      )}
    </>
  );
};

MarkerSummary.propTypes = {
  eventDetails: PropTypes.shape({
    whenDescription: PropTypes.string.isRequired,
  }),
  image: PropTypes.string,
  latLon: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number,
  }).isRequired,
  title: PropTypes.string,

  description: PropTypes.string,
  customDescription: PropTypes.arrayOf(PropTypes.shape({})),

  /* To display the authority banner for the source */
  banner: PropTypes.shape({
    source: PropTypes.string,
    official: PropTypes.bool,
  }),

  // sharing >> these can't be required as currently atons don't have share path
  sharePath: PropTypes.string,
  shareText: PropTypes.string,
  id: PropTypes.string,
  markerType: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonAction: PropTypes.func,
  buttonHref: PropTypes.string,
};

MarkerSummary.defaultProps = {
  image: null,
  title: null,
  eventDetails: null,
  description: null,
  customDescription: null,
  banner: null,

  // Comment default props
  sharePath: undefined,
  shareText: undefined,
  id: undefined,
  markerType: undefined,

  buttonLabel: 'Details',
  buttonAction: undefined,
  buttonHref: null,
};

export default MarkerSummary;
